/* gp-photo-popups.js — pop-ups du module de personnalisation (M. Boursault L. avec Claude)
 * 1. A l'ouverture : message selon la taille (metachamp produit gravurephoto.taille_popup :
 *    petite / autre / texte). Fermeture auto 5 s + bouton « J'ai compris ! ».
 * 2. Apres la 1re photo : proposition de montage (5 s), puis le bouton du montage clignote.
 * 3. Au clic sur « Ajouter au panier » : avertissements + case « replacement des personnages ».
 * Petite medaille : un seul visage -> pas de montage, pas de ligne replacement.
 */
(() => {
  const P = window.GpPhotoElement && window.GpPhotoElement.prototype;
  if (!P || P._gpPopups) return;
  P._gpPopups = 1;


  const DUREE = 5000;
  const MSG = {
    petite: ['Petite médaille : un seul visage possible', 'Ne surchargez pas la gravure : sur une si petite surface, ce ne serait pas visible !'],
    autre: ['Ne surchargez pas la gravure, ce ne serait pas visible !', 'Attention au nombre de visages et au texte trop grand.'],
    texte: ['Ne mettez pas trop de texte', 'Ce ne serait pas lisible !']
  };

  /* ---------- styles + gabarits ---------- */
  const css = `
.gp-pp{position:fixed;inset:0;background:rgba(0,0,0,.45);display:none;align-items:center;justify-content:center;z-index:2147483000;padding:16px}
.gp-pp.gp-open{display:flex;animation:gpPpF .2s ease}
.gp-pp__box{background:#fff;border-radius:14px;max-width:420px;width:100%;padding:26px 24px 22px;box-shadow:0 12px 40px rgba(0,0,0,.25);position:relative;text-align:center;animation:gpPpU .25s ease;font-family:inherit;color:#222}
.gp-pp__x{position:absolute;top:8px;right:10px;background:none;border:0;font-size:26px;line-height:1;color:#888;cursor:pointer;padding:4px 8px}
.gp-pp__ico{font-size:40px;margin-bottom:6px}
.gp-pp__box h3{margin:0 0 10px;font-size:20px;line-height:1.3;color:#222}
.gp-pp__box p{margin:0 0 16px;font-size:15px;line-height:1.45;color:#444}
.gp-pp__price{display:inline-block;background:#f4ede2;color:#7a5a2b;border-radius:20px;padding:3px 12px;font-size:13px;font-weight:600;margin-bottom:16px}
.gp-pp__act{display:flex;flex-direction:column;gap:10px}
.gp-pp__btn{border:0;border-radius:8px;padding:13px;font-size:15px;font-weight:600;cursor:pointer;font-family:inherit}
.gp-pp__pri{background:#b8893f;color:#fff}.gp-pp__pri:hover{background:#a07532}
.gp-pp__sec{background:#fff;color:#b8893f;border:1.5px solid #b8893f}
.gp-pp__lnk{background:none;color:#777;font-weight:400;font-size:14px;text-decoration:underline;padding:6px}
.gp-pp__list{text-align:left;margin:0 0 18px;padding:0;list-style:none}
.gp-pp__list li{display:flex;gap:10px;align-items:flex-start;font-size:15px;line-height:1.4;color:#444;padding:8px 0;border-bottom:1px solid #f0e8db}
.gp-pp__list li:last-child{border-bottom:0}
.gp-pp__list span{font-size:20px;line-height:1.1}
.gp-pp__chk{display:flex;gap:10px;align-items:flex-start;color:#7a5a2b;font-weight:600;cursor:pointer}
.gp-pp__chk input{width:18px;height:18px;accent-color:#b8893f;flex-shrink:0;margin-top:2px}
.gp-pp__t{position:absolute;left:0;right:0;bottom:0;height:4px;background:#f0e8db;border-radius:0 0 14px 14px;overflow:hidden}
.gp-pp__tb{height:100%;width:100%;background:#b8893f;transform-origin:left}
.gp-pp__tb.gp-run{animation:gpPpT var(--d,5s) linear forwards}
.gp-pp__box:hover .gp-pp__tb.gp-run{animation-play-state:paused}
.gp-pulse{animation:gpPpP 1s ease-in-out 3}
@keyframes gpPpT{from{transform:scaleX(1)}to{transform:scaleX(0)}}
@keyframes gpPpF{from{opacity:0}to{opacity:1}}
@keyframes gpPpU{from{transform:translateY(20px);opacity:0}to{transform:none;opacity:1}}
@keyframes gpPpP{0%,100%{box-shadow:0 0 0 0 rgba(184,137,63,.6);transform:scale(1)}50%{box-shadow:0 0 0 10px rgba(184,137,63,0);transform:scale(1.05)}}`;
  const st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  const make = (html) => {
    const o = document.createElement('div');
    o.className = 'gp-pp';
    o.setAttribute('role', 'dialog');
    o.setAttribute('aria-modal', 'true');
    o.innerHTML = `<div class="gp-pp__box">${html}</div>`;
    document.body.appendChild(o);
    return o;
  };

  const ppTaille = make(`<button type="button" class="gp-pp__x" aria-label="Fermer" data-a="x">×</button>
<div class="gp-pp__ico">🔍</div><h3></h3><p></p>
<div class="gp-pp__act"><button type="button" class="gp-pp__btn gp-pp__pri" data-a="x">J'ai compris !</button></div>
<div class="gp-pp__t"><div class="gp-pp__tb"></div></div>`);

  const ppMontage = make(`<button type="button" class="gp-pp__x" aria-label="Fermer" data-a="x">×</button>
<div class="gp-pp__ico">👨‍👩‍👧</div><h3>Plusieurs personnes sur votre bijou ?</h3>
<p>Vous pouvez ajouter d'autres photos (un enfant, un grand-parent, un animal…). Chaque personne est détourée automatiquement, puis vous la placez et l'agrandissez comme vous voulez.</p>
<span class="gp-pp__price">+3 € par photo supplémentaire</span>
<div class="gp-pp__act"><button type="button" class="gp-pp__btn gp-pp__pri" data-a="add">+ Ajouter une personne</button>
<button type="button" class="gp-pp__btn gp-pp__sec" data-a="atelier">L'atelier fait le montage pour moi (+3 €)</button></div>
<div class="gp-pp__t"><div class="gp-pp__tb"></div></div>`);

  const ppFin = make(`<h3>Avant de valider</h3><ul class="gp-pp__list">
<li data-l="ia"><span>🤖</span><div>Photos améliorées par IA si besoin.</div></li>
<li><span>✨</span><div>La gravure apparaît en gris clair sur le métal (pas en noir).</div></li>
<li><span>ℹ️</span><div>Aperçu non contractuel.</div></li>
<li data-l="rep"><label class="gp-pp__chk"><input type="checkbox" checked> L'atelier peut replacer les personnages pour agrandir les visages.</label></li></ul>
<div class="gp-pp__act"><button type="button" class="gp-pp__btn gp-pp__pri" data-a="ok">Ajouter au panier</button>
<button type="button" class="gp-pp__btn gp-pp__lnk" data-a="x">Modifier ma personnalisation</button></div>`);

  /* ---------- minuteur 5 s (pause au survol / toucher) ---------- */
  const auto = (ov, onClose) => {
    const box = ov.querySelector('.gp-pp__box'), bar = ov.querySelector('.gp-pp__tb');
    let t = null, reste = DUREE, debut = 0;
    const start = () => { debut = Date.now(); t = setTimeout(close, reste); };
    const pause = () => { if (t) { clearTimeout(t); t = null; reste -= Date.now() - debut; } };
    function close() {
      if (t) { clearTimeout(t); t = null; }
      const was = ov.classList.contains('gp-open');
      ov.classList.remove('gp-open'); bar.classList.remove('gp-run');
      if (was && onClose) onClose();
    }
    box.addEventListener('mouseenter', pause);
    box.addEventListener('mouseleave', () => { if (ov.classList.contains('gp-open')) start(); });
    box.addEventListener('touchstart', () => { pause(); bar.style.animationPlayState = 'paused'; }, { passive: true });
    ov.addEventListener('click', (e) => { if (e.target === ov || e.target.closest('[data-a="x"]')) close(); });
    return {
      open() {
        ov.classList.add('gp-open'); reste = DUREE;
        bar.style.animationPlayState = ''; bar.style.setProperty('--d', DUREE / 1000 + 's');
        bar.classList.remove('gp-run'); void bar.offsetWidth; bar.classList.add('gp-run');
        start();
      },
      close
    };
  };

  /* ---------- 1. message de taille ---------- */
  const tTaille = auto(ppTaille);
  const showTaille = (el) => {
    const m = MSG[el.gpTaille];
    if (!m || el._gpTailleVu) return;
    el._gpTailleVu = 1;
    ppTaille.querySelector('h3').textContent = m[0];
    ppTaille.querySelector('p').textContent = m[1];
    tTaille.open();
  };

  /* ---------- 2. montage ---------- */
  let cur = null;
  const tMontage = auto(ppMontage, () => {
    const b = cur && cur.fpBox && cur.fpBox.querySelector('.gp-fp-add');
    if (b) { b.classList.remove('gp-pulse'); void b.offsetWidth; b.classList.add('gp-pulse'); }
  });
  ppMontage.addEventListener('click', (e) => {
    const a = e.target.closest('[data-a]'); if (!a || !cur) return;
    if (a.dataset.a === 'add') {
      tMontage.close();
      const inp = cur.fpBox && cur.fpBox.querySelector('input[type=file]');
      inp && inp.click();
    } else if (a.dataset.a === 'atelier') {
      tMontage.close();
      const r = cur.querySelector('.gp-photo__choice input[value="atelier"]');
      if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      if (cur.setWho) cur.setWho('atelier');
      cur.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
  const montageOk = (el) => el.gpTaille !== 'petite' && el.cfg && el.cfg.photo !== false &&
    el.cfg.mode === 'portrait' && el.cfg.montage !== false && el.fpBox;
  const showMontage = (el) => {
    if (!montageOk(el) || el._gpMontageVu) return;
    el._gpMontageVu = 1; cur = el;
    const choix = el.querySelector('.gp-photo__choice');
    ppMontage.querySelector('[data-a="atelier"]').style.display = choix && !choix.hidden ? '' : 'none';
    tMontage.open();
  };
  /* petite médaille : avertissement jaune sous l'aperçu dès qu'une photo est posée */
  const visages = (el, on) => {
    if (el.gpTaille !== 'petite' || (el.cfg && el.cfg.photo === false)) return;
    let w = el._gpVisages;
    if (!w) {
      w = el._gpVisages = document.createElement('p');
      w.className = 'gp-photo__warn gp-pp-visages'; w.setAttribute('role', 'status');
      w.textContent = 'Attention : sur ce petit bijou, s\'il y a deux visages ou plus sur votre photo, ils seront très petits et peu visibles une fois gravés. Choisissez de préférence une photo avec un seul visage.';
      const ref = el.querySelector('.gp-photo__warn:not(.gp-pp-visages)') || el.querySelector('.gp-photo__stage');
      ref && ref.parentNode.insertBefore(w, ref.nextSibling);
    }
    w.hidden = !on;
  };
  const hf = P.handleFile;
  P.handleFile = async function () {
    const r = await hf.apply(this, arguments);
    if (this.orig) { visages(this, true); setTimeout(() => showMontage(this), 600); }
    return r;
  };
  const rs = P.reset;
  P.reset = function () { const r = rs.apply(this, arguments); visages(this, false); return r; };


  /* ---------- montage : ordre des calques (devant / derrière) ----------
     Ordre d'empilement : position 0 = photo principale (dessous), puis les photos du montage. */
  const swapPos = (el, a, b) => {
    if (a === b) return;
    if (a > b) { const t = a; a = b; b = t; }
    if (a > 0) { const f = el.fp, t = f[a - 1]; f[a - 1] = f[b - 1]; f[b - 1] = t; return; }
    const f = el.fp[b - 1], keep = !!(el.el.keep && el.el.keep.checked);
    const m = { orig: el.orig, subject: el.subject, cut: el.cutout, engraved: el.engraved, st: el.st, name: el.fileName, keep, fond: el.fond, pending: el.pending };
    el.orig = f.orig; el.subject = f.subject; el.cutout = f.cut; el.engraved = f.engraved; el.st = f.st;
    el.fileName = f.name; el.fond = f.fond; el.pending = f.pending;
    if (el.el.keep) el.el.keep.checked = !!f.keep;
    Object.assign(f, { orig: m.orig, subject: m.subject, cut: m.cut, engraved: m.engraved, st: m.st, name: m.name, keep: m.keep, fond: m.fond, pending: m.pending });
  };
  const selPos = (el) => {
    const s = (el.sel && (el.sel.kind === 'photo' || el.sel.kind === 'fphoto')) ? el.sel : el._gpLastSel;
    if (!s) return -1;
    if (s.kind === 'photo') return 0;
    if (s.kind === 'fphoto') { const i = (el.fp || []).findIndex((f) => f.st === s.ref); return i < 0 ? -1 : i + 1; }
    return -1;
  };
  const deplace = (el, dir) => {
    const n = (el.fp || []).length, p = selPos(el), msg = el._gpOrdreMsg;
    if (p < 0) { if (msg) { msg.hidden = false; } return; }
    if (msg) msg.hidden = true;
    const q = Math.max(0, Math.min(n, p + dir));
    if (q === p) return;
    swapPos(el, p, q);
    el.sel = q === 0 ? { side: 'face', kind: 'photo', ref: el.st } : { side: 'face', kind: 'fphoto', ref: el.fp[q - 1].st };
    el.fpUi && el.fpUi(); el.draw();
  };
  const tourne = (el) => {                                // la photo du dessous passe tout devant
    const n = (el.fp || []).length;
    for (let k = 0; k < n; k++) swapPos(el, k, k + 1);
    el.sel = null; el._gpLastSel = null;
    el.fpUi && el.fpUi(); el.draw();
  };
  const ordreUi = (el) => {
    const box = el.fpBox;
    if (!box) return;
    let row = el._gpOrdre;
    if (!row) {
      row = el._gpOrdre = document.createElement('div');
      row.className = 'gp-photo__sg-row gp-pp-ordre';
      row.innerHTML = '<button type="button" class="gp-photo__btn" data-o="1" style="font-weight:600;border-color:#b8893f;color:#7a5a2b">⇅ Changer l\'ordre des photos (devant / derrière)</button>';
      row.style.cssText = 'justify-content:center;margin:10px 0';
      row.addEventListener('click', (e) => { e.target.closest('[data-o]') && tourne(el); });
      const stg = el.el && el.el.stage;                  // juste sous l'aperçu, bien visible
      stg && stg.parentNode ? stg.parentNode.insertBefore(row, stg.nextSibling) : box.appendChild(row);
    }
    row.style.display = (el.fp || []).length ? '' : 'none';
  };
  const dr = P.draw;                                     // le bouton suit l'ajout / le retrait des photos
  P.draw = function () {
    if (this.sel && (this.sel.kind === 'photo' || this.sel.kind === 'fphoto')) this._gpLastSel = this.sel;
    fix(this);
    const r = dr.apply(this, arguments);
    this._gpOrdre && (this._gpOrdre.style.display = (this.fp || []).length ? '' : 'none');
    return r;
  };



  /* ---------- montage : on attrape la photo sous le doigt, pas son grand cadre ----------
     Une photo détourée a un cadre plus grand que la personne : on regarde si le point touché
     est sur la personne (pixel non transparent). Sinon on prend le plus petit cadre touché. */
  const alphaCache = new WeakMap();
  const alphaOf = (img) => {
    let a = alphaCache.get(img);
    if (!a) {
      const k = Math.min(1, 240 / Math.max(img.width, img.height)), w = Math.max(1, Math.round(img.width * k)), h = Math.max(1, Math.round(img.height * k));
      const c = document.createElement('canvas'); c.width = w; c.height = h;
      const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, w, h);
      a = { w, h, d: x.getImageData(0, 0, w, h).data }; alphaCache.set(img, a);
    }
    return a;
  };
  const hit0 = P.hitLayer;
  if (hit0) P.hitLayer = function (px, py) {
    if (!this.geo || !this.layers) return hit0.apply(this, arguments);
    const Ls = this.layers(this.side), R = Math.PI / 180;
    let best = null, bestA = Infinity;
    for (let i = Ls.length - 1; i >= 0; i--) {
      const o = Ls[i];
      let b; try { b = this.layerBox(o); } catch (e) { b = null; }
      if (!b || !b.w) { if (o.kind === 'photo' && !best) return hit0.apply(this, arguments); continue; }
      const n = (px - this.geo.cx) / this.geo.k - b.x, m = (py - this.geo.cy) / this.geo.k - b.y,
        c = Math.cos((b.rot || 0) * R), s2 = Math.sin((b.rot || 0) * R), lx = n * c + m * s2, ly = -n * s2 + m * c;
      const dans = Math.abs(lx) <= b.w / 2 + 0.03 && Math.abs(ly) <= b.h / 2 + 0.03;
      if (!dans) continue;
      if (o.kind !== 'photo' && o.kind !== 'fphoto') return o;      // texte, signe : comme avant
      const f = o.kind === 'fphoto' ? (this.fp || []).find((q) => q.st === o.ref) : null;
      const img = f ? f.subject : this.subject;
      if (img) {
        const A = alphaOf(img), u = Math.floor((lx / b.w + 0.5) * A.w), v = Math.floor((ly / b.h + 0.5) * A.h);
        if (u >= 0 && v >= 0 && u < A.w && v < A.h && A.d[(v * A.w + u) * 4 + 3] > 40) return o;   // sur la personne
      }
      if (b.w * b.h < bestA) { bestA = b.w * b.h; best = o; }
    }
    return best;                                     // rien sous le doigt : on laisse défiler la page
  };



  /* ---------- texte et signes : ils ne peuvent plus sortir de la zone gravée (sinon ils disparaissent) ---------- */
  const mv0 = P.layerMove;
  if (mv0) P.layerMove = function (o, dx, dy) {
    const r = mv0.apply(this, arguments);
    if (!o || (o.kind !== 'text' && o.kind !== 'sign') || !this.cfg) return r;
    let b; try { b = this.layerBox(o); } catch (e) { return r; }
    const A = this.cfg.aspect || 1, mx = Math.max(0, 0.46 - b.w / 2), my = Math.max(0, A * 0.46 - b.h / 2);
    const cx = Math.max(-mx, Math.min(mx, b.x)), cy = Math.max(-my, Math.min(my, b.y));
    if (cx !== b.x || cy !== b.y) mv0.call(this, o, cx - b.x, cy - b.y);
    return r;
  };


  /* ---------- dos : zone interdite au centre (ex. médaillon avec cœur incrusté) ----------
     Config produit : "dosTrou": { "x": 50, "y": 46, "r": 19 }  (en % de la zone gravable) */
  const trou = (el, side) => {
    const c = el.cfg && el.cfg.dosTrou;
    if (!c || (side || el.side) !== 'dos') return null;
    const A = el.cfg.aspect || 1;
    return { x: (c.x / 100 - 0.5), y: (c.y / 100 - 0.5) * A, r: c.r / 100 };
  };
  const touche = (el, o, t) => {
    const b = el.layerBox(o);
    const nx = Math.max(b.x - b.w / 2, Math.min(t.x, b.x + b.w / 2)), ny = Math.max(b.y - b.h / 2, Math.min(t.y, b.y + b.h / 2));
    return Math.hypot(nx - t.x, ny - t.y) < t.r ? b : null;
  };
  let enCours = false;
  const pousse = (el, o) => {                       // sort le texte / signe du cercle interdit (et le réduit si besoin)
    if (enCours) return;
    const t = trou(el, 'dos');
    if (el.side !== 'dos' || !t || !o || (o.kind !== 'text' && o.kind !== 'sign')) return;
    enCours = true;
    try {
      for (let k = 0; k < 10; k++) {
        const b = touche(el, o, t);
        if (!b) break;
        const A = el.cfg.aspect || 1, bas = t.y + t.r + b.h / 2 + 0.01, haut = t.y - t.r - b.h / 2 - 0.01;
        const okBas = bas + b.h / 2 <= A / 2, okHaut = haut - b.h / 2 >= -A / 2;
        const cible = (b.y >= t.y && okBas) || !okHaut ? bas : haut;
        mv0.call(el, o, 0, cible - b.y);
        if (touche(el, o, t) && sc0) sc0.call(el, o, 0.85);   // trop grand pour passer : on réduit
      }
    } catch (e) {} finally { enCours = false; }
  };
  const sc0 = P.layerScale;
  const mv1 = P.layerMove;
  P.layerMove = function (o) { const r = mv1.apply(this, arguments); pousse(this, o); return r; };
  const sc1 = P.layerScale;
  if (sc1) P.layerScale = function (o) { const r = sc1.apply(this, arguments); pousse(this, o); return r; };
  const rd1 = P.render;
  P.render = function (t, e, i, sd) {
    const tr = trou(this, sd);
    if (tr && this.layers) { try { this.layers('dos').forEach((o) => pousse(this, o)); } catch (er) {} }
    const r = rd1.apply(this, arguments);
    if (tr && e && i) {
      const { zw, zh, cx, cy } = e, x = cx + tr.x * zw, y = cy + tr.y * zw, R = tr.r * zw;
      t.save();
      t.beginPath(); t.arc(x, y, R, 0, 2 * Math.PI);
      t.fillStyle = 'rgba(200,30,40,.18)'; t.fill();
      t.setLineDash([4, 3]); t.lineWidth = 1.2; t.strokeStyle = 'rgba(160,20,30,.75)'; t.stroke(); t.setLineDash([]);
      t.fillStyle = 'rgba(160,20,30,.85)'; t.font = `600 ${Math.max(10, R * 0.28)}px system-ui,sans-serif`;
      t.textAlign = 'center'; t.textBaseline = 'middle'; t.fillText('cœur', x, y);
      t.restore();
    }
    return r;
  };

  /* ---------- téléphone : le doigt hors d'un élément fait défiler la page ---------- */
  const tactile = (el) => {
    const cv = el.el && el.el.canvas;
    if (!cv || cv._gpTouch) return;
    cv._gpTouch = 1;
    cv.style.touchAction = 'pan-y';
    cv.addEventListener('touchstart', (e) => {
      if (e.touches.length > 1) { e.preventDefault(); return; }
      const r = cv.getBoundingClientRect(), t = e.touches[0], x = t.clientX - r.left, y = t.clientY - r.top;
      let pris = false;
      try { pris = !!((el.hitHandle && el.hitHandle(x, y)) || (el.hitLayer && el.hitLayer(x, y))); } catch (er) { pris = true; }
      if (pris) e.preventDefault();
    }, { passive: false, capture: true });
  };

  /* ---------- texte et signes : clairs sur le métal (comme la gravure réelle) ---------- */
  const CLAIR = { or: '#f0e6cc', or_rose: '#f1e0d8' };
  const enClair = (nom) => {
    const f = P[nom];
    if (!f) return;
    P[nom] = function () {
      const c = this.cfg; if (!c) return f.apply(this, arguments);
      const t = c.tint, b = c.blend;
      c.tint = CLAIR[c.metal] || '#eef0f2'; c.blend = 'screen';
      try { return f.apply(this, arguments); } finally { c.tint = t; c.blend = b; }
    };
  };
  enClair('renderText'); enClair('renderSigns');

  /* ---------- montage : chaque photo cache celle qui est derrière (silhouette pleine) ---------- */
  const L = window.GpPhotoLib;
  if (L && !L._gpOpaque) {
    L._gpOpaque = 1;
    const eng0 = L.engrave;
    L.engrave = function (src, tint, blend) {
      const e = eng0.apply(this, arguments);
      const c = L.canvas(e.width, e.height), x = c.getContext('2d');
      x.drawImage(src, 0, 0, c.width, c.height);              // silhouette de la personne détourée
      x.globalCompositeOperation = 'source-in';
      x.fillStyle = L._gpMetal || '#e6e8ea'; x.fillRect(0, 0, c.width, c.height);
      x.globalCompositeOperation = 'source-over';
      x.drawImage(e, 0, 0);                                     // gravure par-dessus
      return c;
    };
    P.buildEngraved = function () { this.subject && (this.engraved = L.engrave(this.subject, this.cfg.tint, this.cfg.blend)); };
  }
  const opaque = (el) => {
    if (!L || !el.cfg) return;
    L._gpMetal = el.cfg.metalStops ? el.cfg.metalStops[0] : L._gpMetal;
    if (el.subject) el.buildEngraved();
    (el.fp || []).forEach((f) => { if (f.subject) f.engraved = L.engrave(f.subject, el.cfg.tint, el.cfg.blend); });
    el.draw && el.draw();
  };

  /* ---------- 3. avant le panier ---------- */
  let finEl = null;
  ppFin.addEventListener('click', (e) => {
    const a = e.target.closest('[data-a]');
    if (!a) return;
    ppFin.classList.remove('gp-open');
    if (a.dataset.a !== 'ok' || !finEl) return;
    const el = finEl, inp = el._gpRepInput;
    if (inp) {
      const vis = ppFin.querySelector('[data-l="rep"]').style.display !== 'none';
      inp.value = vis ? (ppFin.querySelector('[data-l="rep"] input').checked ? 'Accepté' : 'Refusé') : '';
      inp.disabled = !vis;
    }
    el._gpOkUntil = Date.now() + 120000;
    const f = el.form;
    f.requestSubmit ? f.requestSubmit(el._gpSubmitter && el._gpSubmitter.form === f ? el._gpSubmitter : undefined)
      : f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  });
  window.addEventListener('submit', (e) => {
    const el = [...document.querySelectorAll('gp-photo')].find((g) => g.form === e.target);
    if (!el) return;
    if (el._gpOkUntil && Date.now() < el._gpOkUntil) return;     // déjà validé : on laisse passer
    if (el.who !== 'atelier' && !el.orig && !(el.hasPerso && el.hasPerso())) {
      if (el.cfg && el.cfg.required && el.cfg.photo !== false) return; // le module affiche son erreur
    }
    e.preventDefault(); e.stopImmediatePropagation();
    finEl = el; el._gpSubmitter = e.submitter;
    const photo = el.cfg && el.cfg.photo !== false;
    ppFin.querySelector('[data-l="ia"]').style.display = photo ? '' : 'none';
    ppFin.querySelector('[data-l="rep"]').style.display = photo && el.gpTaille !== 'petite' ? '' : 'none';
    ppFin.classList.add('gp-open');
  }, true);


  /* ---------- boîte cadeau : +2 € (offerte pour l'or) ---------- */
  const BOITE = '50629698355534';
  const boiteUi = (el) => {
    if (el._gpBoite) return;
    const ref = el.querySelector('.gp-photo__notes-box');
    if (!ref) return;
    const vs = document.querySelector('variant-selects, variant-radios, [data-variant-picker]');
    if (vs && /bo[iî]te/i.test(vs.textContent)) return;   // le produit propose déjà la boîte en déclinaison
    const h1 = document.querySelector('h1');
    const or = el._gpOr = !!(h1 && /carat/i.test(h1.textContent));
    const w = el._gpBoite = document.createElement('div');
    w.className = 'gp-pp-boite';
    w.style.cssText = 'margin:14px 0;padding:12px 14px;border:1.5px solid #b8893f;border-radius:10px;background:#fbf7f0;color:#7a5a2b';
    const nm = (el.id || 'gp') + '-emb', rd = 'width:18px;height:18px;accent-color:#b8893f;flex-shrink:0';
    w.innerHTML = `<div style="font-weight:700;margin-bottom:6px">🎁 Emballage</div>` + (or
      ? `<label style="display:flex;gap:10px;align-items:center;font-weight:600"><input type="radio" name="${nm}" value="b" checked style="${rd}"> Boîte cadeau <strong>offerte</strong> pour votre bijou en or</label>`
      : `<label style="display:flex;gap:10px;align-items:center;cursor:pointer;margin-bottom:6px"><input type="radio" name="${nm}" value="p" checked style="${rd}"> Pochette cadeau <strong>offerte</strong></label>` +
        `<label style="display:flex;gap:10px;align-items:center;cursor:pointer"><input type="radio" name="${nm}" value="b" style="${rd}"> Boîte cadeau (+2 €)</label>`);
    ref.parentNode.insertBefore(w, ref);
    w.choix = () => { const r = w.querySelector('input:checked'); return r ? r.value : 'p'; };
    if (el.form) {
      const i = el._gpBoiteInput = document.createElement('input');
      i.type = 'hidden'; i.name = 'properties[Emballage]';
      i.setAttribute('form', el.form.getAttribute('id') || '');
      el.appendChild(i);
      const maj = () => { i.value = w.choix() === 'b' ? (or ? 'Boîte cadeau offerte (or)' : 'Boîte cadeau (+2 €)') : 'Pochette cadeau offerte'; };
      w.addEventListener('change', maj); maj();
    }
  };
  const sup = P.addSupplements;
  P.addSupplements = async function () {
    sup && await sup.apply(this, arguments);
    const b = this._gpBoite;
    if (!b || this._gpOr || b.choix() !== 'b') return;
    const q = this.form && this.form.querySelector('[name="quantity"]'),
      n = Math.max(1, parseInt(q && q.value, 10) || 1), h = document.querySelector('h1'),
      rt = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const r = await fetch(rt + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +BOITE, quantity: n, properties: { Pour: h ? h.textContent.trim().slice(0, 80) : '' } }] }) });
    if (!r.ok) throw new Error('boite cadeau ' + r.status);
  };

  /* le montage et l'atelier sont construits plus tard (au 1er affichage) : on se branche dès qu'ils existent */
  function fix(el) {
    if (!el.gpTaille) el.gpTaille = el.dataset.gpTaille || 'autre';
    if (el.gpTaille === 'petite' && el.cfg) {        // un seul visage : pas de montage
      el.cfg.montage = false;
      if (el.fpBox) { el.fpBox.remove(); el.fpBox = null; }
      el.fp = []; el.fpUi = null;
    }
    boiteUi(el);
    tactile(el);
    if (el.fpBox && !el._gpOrdre) ordreUi(el);
    if (el.fpBox && el.fpUi && !el._gpFpWrap) {        // boutons devant / derrière du montage
      el._gpFpWrap = 1;
      const ui = el.fpUi;
      el.fpUi = function () { ui.apply(this, arguments); ordreUi(this); };
      ordreUi(el);
    }
    if (el.at && el.at.panel && !el._gpRetour) {         // retour facile au montage fait par le client
      const r = el._gpRetour = document.createElement('button');
      r.type = 'button'; r.className = 'gp-photo__btn';
      r.style.cssText = 'margin:0 0 12px;font-weight:600';
      r.textContent = '← Finalement, je fais le montage moi-même';
      r.addEventListener('click', () => {
        const c = el.querySelector('.gp-photo__choice input[value="client"]');
        if (c) c.checked = true;
        el.setWho && el.setWho('client');
        (el.el.stage || el).scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      el.at.panel.prepend(r);
    }
  }

  /* ---------- branchement sur chaque module ---------- */
  const setup = (el) => {
    if (el._gpPp) return; el._gpPp = 1;
    el.gpTaille = el.dataset.gpTaille || 'autre';
    opaque(el);
    fix(el);
    if (el.form && !el._gpRepInput) {
      const i = document.createElement('input');
      i.type = 'hidden'; i.name = 'properties[Replacement des personnages]'; i.disabled = true;
      i.setAttribute('form', el.form.getAttribute('id') || '');
      el.appendChild(i); el._gpRepInput = i;
    }
    const io = new IntersectionObserver((en) => {
      if (en.some((x) => x.isIntersecting)) { io.disconnect(); setTimeout(() => showTaille(el), 400); }
    }, { threshold: 0.3 });
    io.observe(el);
  };
  const init = () => document.querySelectorAll('gp-photo').forEach(setup);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
